module.exports = __webpack_public_path__ + "static/media/40.a22091cf.JPG";